<template>
  <ModalWrapper
    :modalName="modalName"
    maxWidth="max-w-2xl"
    @before-close="cancel"
    paddingsClass="p-6"
  >
    <div>
      <div class="w-full">
        <p class="mb-2 text-xl font-medium text-gray" v-html="title"></p>
      </div>

      <span
        v-html="text"
        class="text-base font-light leading-relaxed text-gray"
      ></span>

      <div>
        <div
          class="mt-5 flex items-center justify-center space-x-2 text-sm md:justify-end"
        >
          <Button
            v-if="hasCancelButton"
            :theme="cancelButtonTheme"
            @click="onClickCancel"
            size="none"
            class="px-5 py-1"
          >
            {{ cancelButtonText }}
          </Button>

          <Button
            :theme="confirmButtonTheme"
            @click="onClickConfirm"
            size="none"
            class="px-5 py-1"
          >
            {{ confirmButtonText }}
          </Button>
        </div>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import isMobile from "@/mixins/isMobile";
import ModalWrapper from "@/components/Core/ModalWrapper.vue";
import Button from "@/components/Core/ButtonBase.vue";

export default {
  name: "ModalConfirm",
  components: {
    ModalWrapper,
    Button,
  },
  mixins: [isMobile],
  data() {
    return {
      modalName: "confirmModal",
    };
  },
  computed: {
    confirm() {
      return this.getModalData(this.modalName).onConfirm;
    },
    cancel() {
      return this.getModalData(this.modalName).onCancel;
    },
    hasCancelButton() {
      return this.getModalData(this.modalName)?.hasCancelButton ?? true;
    },
    cancelButtonText() {
      return (
        this.getModalData(this.modalName)?.cancelButtonText ??
        this.$t("action.cancel")
      );
    },
    cancelButtonTheme() {
      return this.getModalData(this.modalName)?.cancelButtonTheme ?? "link";
    },
    confirmButtonText() {
      return (
        this.getModalData(this.modalName)?.confirmButtonText ??
        this.$t("action.confirm")
      );
    },
    confirmButtonTheme() {
      return (
        this.getModalData(this.modalName)?.confirmButtonTheme ?? "secondary"
      );
    },
    title() {
      return this.getModalData(this.modalName).title;
    },
    text() {
      return this.getModalData(this.modalName).text;
    },
    ...mapGetters({ getModalData: "modals/getModalData" }),
  },
  methods: {
    async onClickCancel() {
      await this.cancel();
      this.closeModal(this.modalName);
    },
    async onClickConfirm() {
      await this.confirm();
      this.closeModal(this.modalName);
    },
    ...mapMutations({
      closeModal: "modals/closeModal",
    }),
  },
};
</script>
